import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';

import { ConfigModel, ModelSearch, DataTablesRequest } from 'projects/ProjetoBaseAngular/domain/models';

import { ConfigModalComponent } from './config-modal/config-modal.component';
import { ConfigService } from 'projects/ProjetoBaseAngular/domain/services';
import { BaseCrudComponent } from 'projects/ProjetoBaseAngular/app/base-crud.component';
import { OptionSearchType, SearchType } from 'projects/ProjetoBaseAngular/domain/types';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-unidade-medida',
  templateUrl: './configs.component.html'
})
export class ConfigsComponent extends BaseCrudComponent<ConfigModel> implements OnInit {
  @ViewChild('configModal') modal: ConfigModalComponent;

  search = new ModelSearch('grupo', OptionSearchType.Contains, SearchType.String);

  selectColumns = [
    { data: 'grupo' }, 
    { data: 'descricao' },       
    { data: 'valor' }
  ];

  constructor(
    injector: Injector,
    readonly configService: ConfigService,
    private dialog: MatDialog
  ) {
    super(injector, configService);
  }

  protected beforeDtRequest(dataTablesParameters: DataTablesRequest): DataTablesRequest {
    const searches = [];
    (this.search.searchTerm) && searches.push(this.search);

    dataTablesParameters.searches = searches;
    return super.beforeDtRequest(dataTablesParameters);
  }

  ngOnInit() {
    super.ngOnInit();    
  }

  create() {
    Swal.fire({
      title: 'Não é possivel criar registros!',
      icon: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      focusConfirm: true,
      confirmButtonText: 'Ok',
    });
  }
}
